export const styles = {
  icon: { color: "#7E7E7E" },
  appIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    px: 1,
  }
}
